import { EmployeeDto } from '@zorro/clients';
import { parseDateISO } from '@zorro/shared/formatters';

import { buildTitleWithFittedName } from './titleWithFittedName';

export const buildCarrierApplicationTitle = (
  carrierName: string,
  employee: Pick<EmployeeDto, 'firstName' | 'lastName'>,
  effectiveFrom: string
): string => {
  const year = parseDateISO(effectiveFrom).year();

  return buildTitleWithFittedName(
    employee,
    `${carrierName} application ${year}`
  );
};

/**
 * The one name a carrier application PDF downloads under. The year comes from
 * the enrollment's effective date rather than the clock, so an application
 * filled in December for January coverage is named for the coverage year.
 * The `.pdf` suffix is load-bearing: the signed URL's content-disposition is
 * what a cross-origin download saves the file as, and a name without an
 * extension lands on disk as something nothing will open.
 */
export const buildCarrierApplicationFileName = (
  carrierName: string,
  employee: Pick<EmployeeDto, 'firstName' | 'lastName'>,
  effectiveFrom: string
): string => {
  return `${buildCarrierApplicationTitle(carrierName, employee, effectiveFrom)}.pdf`;
};
